import { useReducer, useEffect } from 'react';
import { useReactor } from '@livefree/reactive';
import { useSearchParams } from 'react-router';
import { ErrorAlert } from '@/shared/components';
import { Button, Spinner } from '@heroui/react';
import { reactive } from '@/core/reactive/reactive';

const reducer = (state, action) => {
  switch (action.type) {
    case 'logoutId':
      return { ...state, logoutId: action.payload };
    case 'confirm':
      return { ...state, confirm: action.payload };
    case 'message':
      return { ...state, message: action.payload };
    case 'activity':
      return { ...state, activity: action.payload };
    case 'redirecting':
      return { ...state, redirecting: action.payload };
    case 'loggingOut':
      return { ...state, loggingOut: action.payload };
    default:
      return state;
  }
};

export const Logout = reactive.component(
  ({ services, monitors }) => {
    const [params] = useSearchParams();

    const [state, dispatch] = useReducer(reducer, {
      confirm: false,
      message: '',
      activity: 'Logging out...',
      redirecting: false,
      loggingOut: true,
      logoutId: params.get('logoutId'),
    });

    useEffect(() => {
      services.logout.info(state.logoutId);
    }, [state.logoutId, services]);

    useReactor(services.logout.info, {
      success: response => {
        const { payload } = response;
        if (payload.requireLogoutPrompt) {
          dispatch({ type: 'confirm', payload: true });
        } else {
          services.my.clearCache();
          services.logout.logout(state.logoutId);
        }
      },
    });

    useReactor(services.logout.logout, {
      success: response => {
        const { payload } = response;
        if (payload.isSuccessful) {
          dispatch({ type: 'activity', payload: 'Redirecting...' });
          dispatch({ type: 'redirecting', payload: true });
          window.location = payload.redirectUrl || '/';
        } else {
          dispatch({ type: 'message', payload: payload.message });
        }
      },
    });

    useEffect(() => {
      dispatch({
        type: 'loggingOut',
        payload: monitors.logout.executing || monitors.info.executing,
      });
    }, [monitors.logout.executing, monitors.info.executing]);

    return (
      <>
        {state.message && <ErrorAlert message={state.message} />}
        {(state.loggingOut || state.redirecting) && <Spinner label={state.activity} />}
        {!state.loggingOut && state.confirm && (
          <div className="flex flex-col">
            <div className="text-default-500 mb-2">Logout of your LiveFreeID account?</div>
            <Button color="primary" size="sm" onPress={() => {}}>
              Logout
            </Button>
          </div>
        )}
      </>
    );
  },
  {
    name: 'Logout',
    monitors: services => [services.logout.logout, services.logout.info],
  },
);
